import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyPipe'
})
export class CurrencyPipe implements PipeTransform {
    private DECIMAL_SEPARATOR: string = ".";
    private THOUSANDS_SEPARATOR: string = ",";

    transform(value: number | string, fractionSize: number = 2): string {
        if (value == null || value == 0 || value == "")
            return '0';

        // noinspection TypeScriptValidateTypes
        let val = (value || "").toString().split(this.DECIMAL_SEPARATOR);
        val[0] = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

        if (val.length > 1) {
            if (val[1].length < fractionSize) {
                for (let index = 0; val[1].length < fractionSize; index++) {
                    val[1] += '0';
                }
            }
            return val[0] + this.DECIMAL_SEPARATOR + val[1];
        }
        else return val[0];
    }

    transformAbsolute(value: number | string, fractionSize: number = 2): string {
        if (value == null || value == 0 || value == "")
            return '0';

        let absVal = value ? Math.abs(Number(value)) : 0;

        // noinspection TypeScriptValidateTypes
        let [integer] = (absVal || "").toString().split(this.DECIMAL_SEPARATOR);
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
        return integer;
    }

    transformWithNegative(value: number | string, fractionSize: number = 2): string {
        if (value == null || value == 0)
            return '0';

        value = Number(value);

        let subValue = value < 0 ? (0 - value) : value;

        let val = (subValue || "").toString().split(this.DECIMAL_SEPARATOR);
        val[0] = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

        if (val.length > 1) {
            if (val[1].length < fractionSize) {
                for (let index = 0; val[1].length < fractionSize; index++) {
                    val[1] += '0';
                }
            }
            if (value < 0)
                return "(" + val[0] + this.DECIMAL_SEPARATOR + val[1] + ")";
            return val[0] + this.DECIMAL_SEPARATOR + val[1];
        }
        else {
            if (value < 0)
                return "(" + val[0] + ")";
            return val[0];
        }
    }

    transformDollar(value: number | string, fractionSize: number = 2): string {
        if (value == null || value == 0)
            return '0';

        // noinspection TypeScriptValidateTypes
        let [integer] = (value || "").toString().split(this.DECIMAL_SEPARATOR);
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

        if (typeof value === 'string') {
          value = parseFloat(value)
        }

        if (value >= 0) {
          return "$" + integer;
        } else {
          return "-$" + integer.replace("-", "");
        }
    }

    parse(value: string, fractionSize: number = 2): string {
        let [integer] = (value || "").split(this.DECIMAL_SEPARATOR);
        integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");
        return integer;
    }
}
